import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 640; // Tailwind `sm`
/** Tailwind `md` — granica wzorca telefonu (`references/mobile.md` w farmaster-ui-standard). */
export const MD_BREAKPOINT = 768;

function isBelow(px: number): boolean {
	return typeof window !== "undefined" && window.innerWidth < px;
}

function useBelowBreakpoint(px: number): boolean {
	const [below, setBelow] = useState(() => isBelow(px));

	useEffect(() => {
		// jsdom nie ma matchMedia — testy komponentow zostaja na szerokosci okna.
		if (typeof window.matchMedia !== "function") {
			setBelow(isBelow(px));
			return;
		}
		const mql = window.matchMedia(`(max-width: ${px - 1}px)`);
		const handler = (e: MediaQueryListEvent) => setBelow(e.matches);
		mql.addEventListener("change", handler);
		setBelow(mql.matches);
		return () => mql.removeEventListener("change", handler);
	}, [px]);

	return below;
}

export function useIsMobile(): boolean {
	return useBelowBreakpoint(MOBILE_BREAKPOINT);
}

export function useIsBelowMd(): boolean {
	return useBelowBreakpoint(MD_BREAKPOINT);
}
